module.exports = __webpack_public_path__ + "static/thumbnail-42cfb4cc50fa86db30834a1b0b0eb896.png";